import type { Extensions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import LinkExtension from '@tiptap/extension-link';
import ImageExtension from '@tiptap/extension-image';

const ChatImage = ImageExtension.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            fileId: {
                default: null,
                parseHTML: (element: HTMLElement) => element.getAttribute('data-file-id'),
                renderHTML: (attrs: { fileId?: string | null }) =>
                    attrs.fileId ? { 'data-file-id': attrs.fileId } : {}
            }
        };
    }
});

// The chat message schema: every editor that produces chat docs uses it, so they stay interchangeable.
export function chatEditorExtensions(): Extensions {
    return [
        StarterKit.configure({
            heading: false,
            blockquote: false,
            codeBlock: false,
            horizontalRule: false,
            link: false
        }),
        LinkExtension.configure({
            openOnClick: false,
            autolink: true,
            HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' }
        }),
        ChatImage.configure({ inline: true, allowBase64: false })
    ];
}
